<template>
    <filter-component>
        <button @click="setFilter({ case: 'discount' })" class="mdc-tab category-filter-btn" role="tab"
            aria-selected="false" tabindex="1" id="offers" v-if="hasActiveDiscounts">
            <span class="mdc-tab__content">
                <span class="mdc-tab__text-label">{{ trans.get("product.offers") }}</span>
            </span>
            <span class="mdc-tab-indicator">
                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
            </span>
            <span class="mdc-tab__ripple"></span>
        </button>
        <button @click="setFilter({ case: 'newArrival' })" class="mdc-tab" role="tab" aria-selected="true" tabindex="1"
            id="new-arrivals" v-if="hasNewArrivals">
            <span class="mdc-tab__content">
                <span class="mdc-tab__text-label">{{ trans.get("product.new_arrivals") }}</span>
            </span>
            <span class="mdc-tab-indicator">
                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
            </span>
            <span class="mdc-tab__ripple"></span>
        </button>
    </filter-component>
</template>

<script>
import { mapActions } from "vuex";
import { SET_FILTER_CATEGORY_ACTION } from "../../store/shop/types";
import Filter from "./Filter";

export default {
    components: {
        FilterComponent: Filter,
    },
    props: {
        hasActiveDiscounts: {
            default: false,
            type: Boolean
        },
        hasNewArrivals: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        ...mapActions({
            setFilter: SET_FILTER_CATEGORY_ACTION,
        }),
    }
}
</script>
